import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect, MyStore } from 'kts-platform-frame/redux';
import { create } from 'kts-scaffold-framework/utils/form';
import { JSString } from 'kts-scaffold-framework/utils/kit';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Form, Input, Select, Button, Icon, Checkbox, Divider, Row, Col, message } from 'antd';
import { history } from 'kts-platform-frame/routes';
import { Decorators } from 'kts-scaffold-framework/utils/doc';
import CompanyRegisterSucess from './CompanyRegisterSucess';
import { message as messageApi } from 'kts-platform-frame/api';
import EmailSvg from './icon/email';
import CompanySvg from './icon/company';
import AdminSvg from './icon/admin';
import PassSvg from './icon/pass';
import TaxSvg from './icon/tax';
import DeleteSvg from './icon/delete';
import EyeOpenSvg from './icon/eyeOpen';
import EyeCloseSvg from './icon/eyeClose';

const css = require('./index.scss');
const FormItem = Form.Item;
const Option = Select.Option;
const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}
@create()
/** 绑定全局数据 */
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class CompanyRegistration extends ModulesBasic<IProps, ModulesState> {

    public state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount() {
        ModulesAction.checkTicket(JSString.getQueryString(location.search, 'ticket'));
        // setTimeout(() => {
        //     this.props.form.resetFields();
        // }, 500);
        // ModulesAction.checkCompany(JSString.getQueryString(location.search, 'ticket'));
    }
    render() {
        const { form } = this.props; // 获取你的props数据 
        const { getFieldDecorator } = form;
        const { config } = MyStore.instance.getState();
        const _config = JSON.parse(JSON.stringify(config));
        const imgUrl = this.state.imgUrl ? this.state.imgUrl : undefined;
        const backgroundStyle = imgUrl ? {
            'background': `url(${imgUrl})`
        } : {};
        return (
            <ModulesRoot action={ModulesAction}>
                {this.state.success ? <CompanyRegisterSucess /> :
                    <div>
                        <div style={backgroundStyle} className={`${css.companyRegister} ${imgUrl ? css.changeStyleByCompany : ''}`}>
                            <div className={css.backgroundMask}/>
                            <div className={css.header}>
                                <img src={require('./IMG.LogText.png')} />
                            </div>
                            <div className={css.register}>
                                <Form onSubmit={this.handleSubmit}>
                                    <Row>
                                        <Col span={12}>
                                            <div className={css.left}>
                                                <div className={css.company}>{this.state.inviteCompanyName}</div>
                                                <div className={css.invite}>向您发出&nbsp;<span>业务邀请</span>&nbsp;</div>
                                                <div className={css.info}><span>注册</span>&nbsp;并建立&nbsp;<span>连接</span>&nbsp;后便可与其开始&nbsp;<span>线上业务。</span></div>
                                                {/* <div className={css.info}>同时，您也将享有&nbsp;<span>FA TMGP30000家</span>&nbsp;企业资源。</div> */}
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className={css.right}>
                                                <div className={css.title}>填写少量信息，建立与{this.state.inviteCompanyName}的业务连接</div>
                                                <FormItem
                                                    label={this.state.inputState.email ? <div className={css.labelStyle}>联系人邮箱<span>*</span></div> : ''}
                                                    {...formItemLayout}
                                                >
                                                    {getFieldDecorator('email', {
                                                        initialValue: this.state.currentEmail,
                                                        // rules: [Decorators.password()
                                                        // ],
                                                        rules: [{
                                                            required: true,
                                                            type: 'email',
                                                            // pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                                                            message: "支持邮箱格式",
                                                        },
                                                        { validator: this.emailCheck }
                                                        ],
                                                    })(
                                                        <Input
                                                            // type="text"
                                                            placeholder={this.state.inputState.email ? '' : '联系人邮箱*'}
                                                            prefix={
                                                                <i dangerouslySetInnerHTML={{ __html: EmailSvg }} />
                                                            }
                                                            suffix={
                                                                <i dangerouslySetInnerHTML={{ __html: DeleteSvg }} />
                                                            }
                                                            autoComplete="off"
                                                            onChange={ModulesAction.onChangeEmail}
                                                            onFocus={ModulesAction.onInputFocus}
                                                            onBlur={ModulesAction.onInputBlur}
                                                        />
                                                    )}
                                                </FormItem>
                                                <div className={css.emailTips}>
                                                    此联系人将作为您公司在FA TMGP平台的系统管理员，邮箱将作为其登录账号名，请合理安排。
                                            </div>
                                                <FormItem
                                                    label={this.state.inputState.nickName ? <div className={css.labelStyle}>联系人姓名<span>*</span></div> : ''}
                                                    {...formItemLayout}
                                                >
                                                    {getFieldDecorator('nickName', {
                                                        rules: [{ required: true, message: '公司联系人不能为空' }],
                                                        // initialValue: this.state.info.nickName,
                                                    })(
                                                        <Input
                                                            prefix={
                                                                <i dangerouslySetInnerHTML={{ __html: AdminSvg }} />
                                                            }
                                                            placeholder={this.state.inputState.nickName ? '' : '联系人姓名*'}
                                                            onFocus={ModulesAction.onInputFocus}
                                                            onBlur={ModulesAction.onInputBlur}
                                                        />
                                                    )}
                                                </FormItem>
                                                <FormItem
                                                    label={this.state.inputState.companyName ? <div className={css.labelStyle}>公司全称<span>*</span></div> : ''}
                                                    {...formItemLayout}
                                                >
                                                    {getFieldDecorator('companyName', {
                                                        // initialValue: this.state.info.companyName,
                                                        rules: [
                                                            { required: true, message: '公司名称不能为空' },
                                                            { validator: this.companyNameCheck }
                                                        ],
                                                    })(
                                                        <Input
                                                            prefix={
                                                                <i dangerouslySetInnerHTML={{ __html: CompanySvg }} />
                                                            }
                                                            placeholder={this.state.inputState.companyName ? '' : '公司全称*'}
                                                            onFocus={ModulesAction.onInputFocus}
                                                            onBlur={ModulesAction.onInputBlur}
                                                        />
                                                    )}
                                                </FormItem>
                                                <FormItem
                                                    label={this.state.inputState.taxId ? <div className={css.labelStyle}>公司纳税人识别号<span>*</span></div> : ''}
                                                    {...formItemLayout}
                                                >
                                                    {getFieldDecorator('taxId', {
                                                        rules: [
                                                            { required: true, message: '公司纳税人识别号不能为空' },
                                                            { type: 'string', pattern: /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/, required: false, message: '15或17或18或20位大写字母、数字组成', whitespace: true },
                                                            { validator: this.companyTaxidCheck }
                                                        ],
                                                    })(
                                                        <Input
                                                            prefix={
                                                                <i dangerouslySetInnerHTML={{ __html: TaxSvg }} />
                                                            }
                                                            placeholder={this.state.inputState.taxId ? '' : '公司纳税人识别号*'}
                                                            onFocus={ModulesAction.onInputFocus}
                                                            onBlur={ModulesAction.onInputBlur}
                                                        />
                                                    )}
                                                </FormItem>
                                                <FormItem
                                                    label={this.state.inputState.pass ? <div className={css.labelStyle}>设置密码<span>*</span></div> : ''}
                                                    {...formItemLayout}
                                                >
                                                    {getFieldDecorator('pass', {
                                                        // rules: [Decorators.password()
                                                        // ],
                                                        rules: [{
                                                            required: true,
                                                            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/,
                                                            message: "由字母加数字构成,区分大小写，长度为6位以上",
                                                            whitespace: true
                                                        }],
                                                    })(
                                                        <Input
                                                            placeholder={this.state.inputState.pass ? '' : '设置密码*'}
                                                            type={this.state.ispwdOpen ? 'text' : 'password'}
                                                            prefix={
                                                                <i dangerouslySetInnerHTML={{ __html: PassSvg }} />
                                                            }
                                                            suffix={
                                                                this.state.ispwdOpen ?
                                                                <i dangerouslySetInnerHTML={{ __html: EyeCloseSvg }} onClick={ModulesAction.handlePwdShow}/>
                                                                :
                                                                <i dangerouslySetInnerHTML={{ __html: EyeOpenSvg }} onClick={ModulesAction.handlePwdShow}/>
                                                            }
                                                            autoComplete="new-password"
                                                            onFocus={ModulesAction.onInputFocus}
                                                            onBlur={ModulesAction.onInputBlur}
                                                        />
                                                    )}
                                                </FormItem>
                                                <div className={css.file}>
                                                    <Checkbox onChange={ModulesAction.agree}>
                                                        我已阅读并同意<a target="_blank" href="/serviceagreement">《个人信息保护声明》</a> | <a target="_blank" href="/privacyagreement">《隐私政策》</a>
                                                    </Checkbox>
                                                </div>
                                                <div className={css.actionCont}>
                                                    <Button type="primary" htmlType="submit" disabled={!this.state.isAgree} className={css.registerBtn}>注册</Button>
                                                    <Button onClick={() => { history.goBack(); }} className={css.giveUp}>放弃</Button>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </div>}
            </ModulesRoot>
        );
    }
    /**
     * 获取表单信息
     */
    private handleSubmit = (e) => {
        if (!this.state.isAgree) {
            message.info('请勾选同意协议！');
            return false;
        }
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                values = {
                    ...values,
                    // email: values.inviteEmail,
                    // pass: values.invitePass,
                };
                ModulesAction.activeCompany(values);
            }
        });
        return true;
    }

    /** 清除邮箱输入框内容 */
    private clearEmail = () => {
        this.props.form.setFieldsValue({ email: undefined });
    }

    private emailCheck = async (rule, value, callback) => {
        const email = this.props.form.getFieldValue('email');
        const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        const emailMacth = reg.test(email);
        if (email && this.state.currentEmail && emailMacth) {
            const res = await ModulesAction.registryInfoCheck({
                email
            });
            if (res && Array.isArray(res)) {
                res.forEach(element => {
                    if (element.paramName === 'email' && !element.checkState) {
                        callback('该邮箱已使用');
                    }
                });
            } else {
                callback();
            }
        }
    }
    private companyNameCheck = async (rule, value, callback) => {
        const companyName = this.props.form.getFieldValue('companyName');
        if (companyName) {
            const res = await ModulesAction.registryInfoCheck({
                companyName
            });
            if (res && Array.isArray(res)) {
                res.forEach(element => {
                    if (element.paramName === 'companyName' && !element.checkState) {
                        callback('该公司已存在');
                    }
                });
            } else {
                callback();
            }
        }
    }

    private companyTaxidCheck = async (rule, value, callback) => {
        const taxId = this.props.form.getFieldValue('taxId');
        const reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
        const companyTaxidMacth = reg.test(taxId);
        if (companyTaxidMacth && taxId && (taxId.length === 15 || taxId.length === 17 || taxId.length === 18 || taxId.length === 20)) {
            const res = await ModulesAction.registryInfoCheck({
                taxId
            });
            if (res && Array.isArray(res)) {
                res.forEach(element => {
                    if (element.paramName === 'taxId' && !element.checkState) {
                        callback('该纳税人识别号已存在');
                    }
                });
            } else {
                callback();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/PublicCompanyRegister/index.tsx